class GLBuffer {
  constructor(buffer) {
    this.buffer = buffer || null;
    this.updateID = -1;
    this.byteLength = -1;
    this.refCount = 0;
  }
}

export { GLBuffer };
//# sourceMappingURL=GLBuffer.mjs.map
